import { render, staticRenderFns } from "./TopicNav.vue?vue&type=template&id=7e2218ee&scoped=true&"
import script from "./TopicNav.vue?vue&type=script&lang=js&"
export * from "./TopicNav.vue?vue&type=script&lang=js&"
import style0 from "./TopicNav.vue?vue&type=style&index=0&id=7e2218ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2218ee",
  null
  
)

export default component.exports